export const VIDEO_FINISHED = 'videoPlayed';
export const PLAYBACK_READY = 'playbackReady';
export const VIDEO_HMTL_CREATED = 'videoControllerVideoElementCreated';
export const VIDEO_STARTED = 'play'
export const ALL_OOYALA_EVENTS = '*';



// WEBPACK FOOTER //
// ./modules/Ooyala/component/PlayerEventNames.js